"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NotFoundContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faGhost = require("@fortawesome/pro-regular-svg-icons/faGhost");

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var NotFoundContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n    height: 100%;\n\n    p {\n        font-size: 1.1rem;\n    }\n"])));

exports.NotFoundContainer = NotFoundContainer;

var NotFoundMessage = function NotFoundMessage(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? '/' : _ref$url,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "The page you're looking for could not be found." : _ref$message,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === void 0 ? 'Go to Dashboard' : _ref$buttonLabel;
  return /*#__PURE__*/_react["default"].createElement(NotFoundContainer, {
    "data-testid": "not-found-message"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faGhost.faGhost,
    size: "6x",
    className: "mb-3"
  }), /*#__PURE__*/_react["default"].createElement("p", null, message), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: url,
    className: "btn btn-primary"
  }, buttonLabel));
};

var _default = NotFoundMessage;
exports["default"] = _default;